import React, { useState } from 'react'

import { ActionsBar, Button, Checkbox, Modal, Text } from '@fielded/shared-ui'

const ConfirmPickupModal = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  const [isAcknowledged, setIsAcknowledged] = useState(false)

  const onToggleCheckbox = (e) => {
    const isToggled = isAcknowledged
    setIsAcknowledged(!isToggled)
  }

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      title='Verify and proceed with delivery'
      centered={false}
    >
      <div className='vs-u-column-spaced'>
        <Text className='vs-u-margin-bottom'>
          Before starting your trip, please ensure you have confirmed all products and quantities match the packing note.
        </Text>
        <Text className='vs-u-margin-bottom'>
          <Checkbox.Stateless
            className='driver-delivery-card-container__select-all'
            label='I acknowledge full responsibility for the items in my custody. I understand that any discrepancies upon delivery will be my accountability.'
            checked={isAcknowledged}
            onChange={e => onToggleCheckbox(e)}
          />
        </Text>
        <ActionsBar>
          <Button
            onClick={() => onConfirm()}
            fill='full'
            colorVariant='warning'
            disabled={!isAcknowledged}
          >
            Start trip
          </Button>
          <Button
            onClick={() => onClose()}
            colorVariant='brand'
          >
            Back to editing
          </Button>
        </ActionsBar>
      </div>
    </Modal>
  )
}

export default ConfirmPickupModal
